export const apiRoutes = {
  oAuthLogin: '/oauth/login',
  oAuth: '/oauth/status',
  logout: '/oauth/logout',
  encryptApiKey: '/encrypt',

  // MCP Server routes
  mcpEncrypt: '/encrypt',
  mcpCsvUpload: '/onboarding/upload',

  // Recommended prompts
  recommendedPrompts: '/threads/recommended-prompts',

  // Team leader
  teamLeader: '/threads/:threadId/team-leader',
} as const;
